import { PushNotifications } from '@capacitor/push-notifications';
import * as Sentry from '@sentry/vue';

import { useAuthStore } from '@/store/auth';

const notificationService = {
  async init() {
    const authStore = useAuthStore();

    // Request permission for notifications
    await PushNotifications.requestPermissions().then((result) => {
      if (result.receive === 'granted') {
        PushNotifications.register();
      }
    });

    // Listen for registration
    await PushNotifications.addListener('registration', (token) => {
      authStore.setDeviceToken(token.value);
    });

    // Listen for registration errors
    await PushNotifications.addListener('registrationError', (error) => {
      Sentry.captureException(error);
    });

    // Listen for push notification received
    PushNotifications.addListener(
      'pushNotificationReceived',
      (notification) => {
        console.log('Push notification received:', notification);
      },
    );

    // Listen for push notification action performed
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification) => {
        console.log('Push notification action performed:', notification);
      },
    );

    return null;
  },
};

export default notificationService;
